<tvcore-alert (close)="clearToast()" *ngIf="toast$ | async as toast" [action]="toast.action" [stretch]="true" [type]="toast.type">
	<p [innerHTML]="getMessage(toast)"></p>
</tvcore-alert>
